import {
    Anchor,
    Button,
    Container,
    Divider,
    Group,
    Loader,
    Paper,
    PasswordInput,
    Radio,
    Text,
    TextInput,
    Title,
    Select,
    
} from '@mantine/core';
import {  DatePickerInput } from '@mantine/dates';

import { Helmet } from "react-helmet-async";
import { IconBrandFacebook, IconBrandGoogle } from "@tabler/icons-react";
import { useState } from 'react';
import { isEmpty } from '../utils/FormValidator';
import { makePostRequest } from '../services/httpHelper';
import { Navigate } from 'react-router-dom';
import { BASE_URL } from '../services/paths';
import { CountrySelect } from '../components';
import { Link } from 'react-router-dom';

const SignupPage = () => {
   
    const [values, setValues] = useState({
        email: '',
        mobile_number: '',
        password: '',
        password_confirm: '',
        first_name: '',
        last_name: '',
        date_of_birth: null as Date | null,
        orgName: '',
        taxId: '',
        regNumber: '',
        authorizedPerson: '',
        authorizedPosition: '',
        orgType: '' as string | null,
        accountType: 'individual',
    });

   
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [isSuccess, setIsSuccess] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('');
   // const [selectedCountryError,setSelectedCountryError]= useState('')
    const [errors, setErrors] = useState<Record<string, string>>({});





    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValues({
            ...values,
            [e.target.name]: e.target.value
        });
    };

    function calculateAge(dateOfBirth: Date | null): number {
        if (!dateOfBirth) return 0; // Handle null case
      
        const today = new Date();
        const birthDate = new Date(dateOfBirth);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
      
        // Adjust age if the birth month hasn't passed yet this year
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        
        return age;
      }

      const validateForm = () => {
        let newErrors: Record<string, string> = {};

        // Individual & Organization shared validation
        if (!values.first_name.trim()) newErrors.first_name = "First name is required.";
        if (!values.last_name.trim()) newErrors.last_name = "Last name is required.";
        if (!values.email.trim()) newErrors.email = "Email is required.";
        if (!values.password.trim() || values.password.length < 6) newErrors.password = "Password must be at least 6 characters.";
        if (values.password !== values.password_confirm) newErrors.password_confirm = "Passwords do not match.";
        if (!values.mobile_number.trim()) newErrors.mobile_number = "Mobile number is required.";
        if (!selectedCountry) newErrors.country = "Country is required.";
        if (values.date_of_birth && calculateAge(values.date_of_birth) < 18) newErrors.date_of_birth = "You must be at least 18 years old.";

        // Organization-specific validation
        if (values.accountType === "organization") {
            if (!values.orgName.trim()) newErrors.orgName = "Organization name is required.";
            if (!values.orgType) newErrors.orgType = "Organization type is required.";
           /* if (!values.taxId.trim()) newErrors.taxId = "Tax ID is required.";
            if (!values.regNumber.trim()) newErrors.regNumber = "Registration number is required.";
            if (!values.authorizedPerson.trim()) newErrors.authorizedPerson = "Authorized person is required.";
            if (!values.authorizedPosition.trim()) newErrors.authorizedPosition = "Authorized position is required.";*/
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSignup = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setError(null);
        setIsSubmitting(true);  
        
        if (!validateForm()) {
            setIsSubmitting(false);
            return;
        }

      
        const data = {
            ...values,
            country: selectedCountry,
            date_of_birth: values.date_of_birth,
        };
        console.log('Signup data',data)

      

        

        try {
            const res = await makePostRequest('auth/signup', data);
            if (res && res.errorMessage) {
                setIsSubmitting(false);
                setError(res.errorMessage);
            } else {
                console.log(res.data)
                setIsSuccess(true);
                setIsSubmitting(false);
                setError(null);
            }

           // if (res.errorMessage) throw new Error(res.errorMessage);

           // setIsSuccess(true);
        } catch (err) {
            setError(err instanceof Error ? err.message : "An unexpected error occurred.");
        } finally {
            setIsSubmitting(false);
        }
    };

    

    const maxDate = new Date();
maxDate.setFullYear(maxDate.getFullYear() - 17);

    return (
        <>
            <Helmet>
                <title>Signup</title>
            </Helmet>
            <Container size={420} my={40}>
                <Title align="center" sx={() => ({ fontWeight: 900 })}>
                    Welcome back!
                </Title>
                <Text color="dimmed" size="sm" align="center" mt={5}>
                    Already have an account?{' '}
                    <Link to="/login">
                        <Anchor size="sm" component="button">
                            <strong>Login</strong>
                        </Anchor>
                    </Link>
                </Text>
                {isSubmitting && <Loader/>}

                <Paper withBorder shadow="md" p={30} mt={30} radius="md">
                    <Group grow mb="md" mt="md">
                        <Button radius="xl" leftIcon={<IconBrandFacebook size={16} />} onClick={() => window.location.href = `${BASE_URL}auth/facebook`}>Facebook</Button>
                        <Button radius="xl" leftIcon={<IconBrandGoogle size={16} />} onClick={() => window.location.href = `${BASE_URL}auth/google`}>Google</Button>
                    </Group>
                    <Divider label="Or continue with email" labelPosition="center" my="lg" />
                    {isSubmitting && <Loader />}
                    {isSuccess && <Navigate to={`/verify-email/${values.email}`} />}
                    {error && <p className='error'>{error}</p>}

                    <Group>
                        <Radio
                            label="Individual"
                            value="individual"
                            checked={values.accountType === 'individual'}
                            onChange={() => setValues({ ...values, accountType: 'individual' })}
                        />
                        <Radio
                            label="Organization"
                            value="organization"
                            checked={values.accountType === 'organization'}
                            onChange={() => setValues({ ...values, accountType: 'organization' })}
                        />
                    </Group>

                    <TextInput label="First Name" name="first_name" onChange={handleChange} value={values.first_name} error={errors.first_name} placeholder='First Name'/>
                    <TextInput label="Last Name" name="last_name" onChange={handleChange} value={values.last_name} error={errors.last_name} placeholder='Last Name' />
                    <TextInput label="Email" name="email" onChange={handleChange} value={values.email} error={errors.email} placeholder='Email'/>
                    <TextInput label="Phone" name="mobile_number" onChange={handleChange} value={values.mobile_number} error={errors.mobile_number} placeholder='Mobile Number' />

                                   
                    <DatePickerInput
                        value={values.date_of_birth}
                        onChange={(date) => setValues({ ...values, date_of_birth: date })}
                        label="Date of Birth"
                        placeholder="Select Date of Birth"
                        maxDate={new Date()} 
                        minDate={new Date(1940, 0, 1)}
                        allowDeselect
                        defaultLevel="decade" // Start from decade view for easier navigation
                        popoverProps={{ withinPortal: true }} // Ensures the picker is not cut off in modals
                        clearable
                        error={errors.date_of_birth} 
                        />



               <CountrySelect value={selectedCountry} onChange={setSelectedCountry} />
                {errors.country && <Text color="red">{errors.country}</Text>}
                    {/*<CountrySelect value={selectedCountry} onChange={handleCountryChange} />
                    {selectedCountryError && <p className='error'>{selectedCountryError}</p>}*/}

               <PasswordInput label="Password" placeholder="Password" name="password" onChange={handleChange} value={values.password} mt="md" />
                                    {!isEmpty(errors.password) && <p className='error'>{errors.password}</p>}
                <PasswordInput label="Confirm Password" placeholder="Confirm Password" name="password_confirm" onChange={handleChange} mt="md" />
                    {!isEmpty(errors.password_confirm) && <p className='error'>{errors.password_confirm}</p>}                  
                                 
                              

                  
                    {values.accountType === 'organization' && (
                        <>
                            <TextInput label="Organization Name" name="orgName" onChange={handleChange} value={values.orgName} error={errors.orgName} />
                            <Select label="Organization Type" data={['NGO', 'Company', 'Cooperative']} value={values.orgType} onChange={(val) => setValues({ ...values, orgType: val })} error={errors.orgType} />
                            {/*<TextInput label="Authorized Person" placeholder="Authorized Person" name="authorizedPerson" onChange={handleChange} value={values.authorizedPerson} mt="md" />
                            {!isEmpty(errors.authorizedPerson) && <p className='error'>{errors.authorizedPerson}</p>}
                            <TextInput label="Authorized Position" placeholder="Authorized Position" name="authorizedPosition" onChange={handleChange} value={values.authorizedPosition} mt="md" />
                            {!isEmpty(errors.authorizedPosition) && <p className='error'>{errors.authorizedPosition}</p>}
                            <TextInput label="Tax ID" name="taxId" onChange={handleChange} value={values.taxId} error={errors.taxId} />
                            <TextInput label="Registration Number" name="regNumber" onChange={handleChange} value={values.regNumber} error={errors.regNumber} />*/}
                        </>
                    )
                    
                    }




                    

                    {
                    /*values.accountType === 'organization' && (
                        <>
                            <TextInput label="Organization Name" placeholder="Organization Name" name="orgName" onChange={handleChange} value={values.orgName} mt="md" />
                            {!isEmpty(errors.orgName) && <p className='error'>{errors.orgName}</p>}
                            <Select
                                label="Organization Type"
                                placeholder="Select organization type"
                                name="orgType"
                                value={values.orgType}
                                onChange={(value) => setValues({ ...values, orgType: value })}
                                mt="md"
                                data={[
                                    { value: 'charity', label: 'Charity' },
                                    { value: 'church', label: 'Church' },
                                    { value: 'company', label: 'Company' },
                                    { value: 'non-profit', label: 'Non-Profit' },
                                ]}
                            />
                            <TextInput label="Tax ID" placeholder="Tax ID" name="taxId" onChange={handleChange} value={values.taxId} mt="md" />
                            {!isEmpty(errors.taxId) && <p className='error'>{errors.taxId}</p>}
                            <TextInput label="Registration Number" placeholder="Registration Number" name="regNumber" onChange={handleChange} value={values.regNumber} mt="md" />
                            {!isEmpty(errors.regNumber) && <p className='error'>{errors.regNumber}</p>}
                            <TextInput label="Authorized Person" placeholder="Authorized Person" name="authorizedPerson" onChange={handleChange} value={values.authorizedPerson} mt="md" />
                            {!isEmpty(errors.authorizedPerson) && <p className='error'>{errors.authorizedPerson}</p>}
                            <TextInput label="Authorized Position" placeholder="Authorized Position" name="authorizedPosition" onChange={handleChange} value={values.authorizedPosition} mt="md" />
                            {!isEmpty(errors.authorizedPosition) && <p className='error'>{errors.authorizedPosition}</p>}
                        </>
                    )*/
                    
                    }

                    <Button fullWidth mt="xl" size="md" onClick={handleSignup} disabled={isSubmitting}>
                        Sign Up
                    </Button>
                </Paper>
            </Container>
        </>
    );
};

export default SignupPage;
